import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  createEnterKeyHandler,
  deprecatedProp,
  generateTestIds,
} from '@homebase/common';
import {CSSTransition} from 'react-transition-group';
import Translation from '@wayfair/translation';
import './Veil.$BRAND.css.js';

const ANIMATION_TIMEOUT_MS = 250;

class Veil extends PureComponent {
  // From https://github.com/facebook/react/issues/9809 this prevents the handler from being called twice on touch devices
  componentDidMount() {
    this.veilNode.addEventListener('touchstart', this.handleTouch);
  }
  componentWillUnmount() {
    this.veilNode.removeEventListener('touchstart', this.handleTouch);
  }
  handleTouch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleClick(e);
  };
  assignRefs = (node) => {
    if (this.props.innerRef) {
      this.props.innerRef(node);
    }
    this.veilNode = node;
  };
  render() {
    return (
      <CSSTransition
        in={!this.props.willClose}
        appear
        timeout={ANIMATION_TIMEOUT_MS}
        classNames="Veil"
      >
        <div
          className={cx({
            Veil: true,
            'has-overlay': this.props.isVisible,
            'has-elevatedIndex': this.props.hasElevatedIndex,
            'has-lowIndex': this.props.hasLowIndex,
          })}
          role="button"
          onClick={this.props.handleClick}
          onKeyPress={createEnterKeyHandler(this.props.handleClick)}
          data-enzyme-id={this.props.enzymeId}
          data-codeception-id={this.props.codeceptionId}
          data-hb-id="Veil"
          ref={this.assignRefs}
          tabIndex="0"
          aria-label={Translation({msgid: 'veil.close'})}
          {...generateTestIds({testIds: this.props.testIds})}
        />
      </CSSTransition>
    );
  }
}

Veil.propTypes = {
  // Whether or not the overlay has a visible background color
  isVisible: PropTypes.bool,
  // Callback function for when a user clicks on the overlay
  handleClick: PropTypes.func.isRequired,
  // Whether or not the overlay is about to close
  willClose: PropTypes.bool,
  // Whether or not the overlay has an elevated z-index
  // @NOTE this should be resolved once the responsive modal has a lower z-index
  hasElevatedIndex: PropTypes.bool,
  // Whether or not the overlay has a shallow z-index
  // @NOTE this should be resolved once the mobile web modal is fully deprecated
  hasLowIndex: PropTypes.bool,
  // A function to access the reference to the veil element
  innerRef: PropTypes.func,
  // Optional Enzyme and Codeception testing identifiers
  testIds: PropTypes.shape({
    enzyme: PropTypes.string,
    codeception: PropTypes.string,
  }),
  // @ignore-prop-docs
  enzymeId: deprecatedProp('Please use the `testIds` prop instead.'),
  // @ignore-prop-docs
  codeceptionId: deprecatedProp('Please use the `testIds` prop instead.'),
};
Veil.defaultProps = {
  isVisible: true,
  willClose: false,
  hasElevatedIndex: false,
  hasLowIndex: false,
  innerRef: null,
};

export default Veil;
